import { Module } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import { mutations } from './mutation'
import { getters } from './getters'
import { actions } from './actions'
import { state } from './state'
import NetsuiteData from '../types/NetsuiteData'

export const module: Module<NetsuiteData, RootState> = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state
}
